<template>
  <mobile-responsive-shell :title="title">
    <div class="credit-mobile-form">
      <div class="mb-3">
        <label class="form-label">Client</label>
        <select
          class="form-select"
          v-model="payment.customer_reference"
          @change="getCustomerSalesUnpaid(payment.customer_reference)"
        >
          <option value=""></option>
          <option
            v-for="(customer, index) in customers"
            :key="index"
            :value="customer.reference"
          >
            {{ customer.fullName }}
            {{ customer.society ? " — " + customer.society : "" }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label class="form-label">Factures impayées</label>
        <select class="form-select" v-model="payment.sale_reference">
          <option value=""></option>
          <option
            v-for="(sale, index) in sales"
            :key="index"
            :value="sale.reference"
          >
            Nº {{ sale.reference }} · {{ sale.date }} · reste {{ sale.amountUnpaid }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label class="form-label">Montant</label>
        <input type="text" v-model="payment.amount" class="form-control" />
      </div>

      <div class="mb-3">
        <label class="form-label">Mode de paiement</label>
        <select v-model="payment.paymentMethod" class="form-select">
          <option value="Espèce">Espèce</option>
          <option value="Virement bancaire">Virement bancaire</option>
          <option value="Chèque">Chèque</option>
          <option value="Carte bancaire">Carte bancaire</option>
        </select>
      </div>

      <div class="mb-3">
        <label class="form-label">Nº chèque</label>
        <input type="text" v-model="payment.checkNumber" class="form-control" />
      </div>

      <div class="mb-3">
        <label class="form-label">Nº virement</label>
        <input
          type="text"
          v-model="payment.bankTransferNumber"
          class="form-control"
        />
      </div>

      <div class="mb-3">
        <label class="form-label">Remarques</label>
        <textarea class="form-control" rows="3"></textarea>
      </div>

      <button type="button" class="btn btn-success w-100 py-2" @click="save(payment)">
        <i class="bi bi-check-square-fill"></i> Enregistrer
      </button>
    </div>
  </mobile-responsive-shell>
</template>

<script>
import { mapGetters } from "vuex";
import MobileResponsiveShell from "../../components/MobileResponsiveShell.vue";

export default {
  name: "MobileCreditsSuppliersCreate",
  components: { MobileResponsiveShell },
  data() {
    return {
      title: "Nouveau paiement",
      payment: {},
    };
  },
  computed: {
    ...mapGetters("customer", {
      customers: "getAll",
    }),
    ...mapGetters("sale", { sales: "getSales" }),
  },
  methods: {
    async save(data) {
      await this.$store.dispatch("payment/store", data);
    },
    getCustomerSalesUnpaid(customer_reference) {
      this.$store.dispatch("sale/getCustomerSalesUnpaid", customer_reference);
    },
  },
  beforeMount() {
    this.$store.dispatch("customer/getAll");
  },
};
</script>

<style scoped>
.credit-mobile-form {
  max-width: 520px;
  margin: 0 auto;
}
</style>
